'use strict';

import {module} from '../../app';
import moment from 'moment';

module.service('dateFormattingHelper', ['techpadConfig', function (techpadConfig) {
  let self = this;

  self.maxMonth = 12;
  self.maxDays = [ 31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];

  self.formatDateValue = (date, maxYear) => {
    if(date == '') {
      return "";
    }
    date = date.replace(/\D/g, '');
    let month = date.substring(0, 2);
    let day = date.substring(2, 4);
    let year = date.substring(4, 8);

    if (month == '00') {
      month = '';
    }
    if (day == '00') {
      day = '0';
    }
    if (year == '0') {
      year = '';
    }
    if (month < 10 && month != '1' && month.length == 1 && month != '0') {
      month = '0'+ month;
    } 
    if (day > 3 && day < 10  && day.length == 1 && day != '0') {
      day = '0'+ day;
    }

    let isMonthValid = month <= self.maxMonth;
    let isYearValid = year < maxYear;
    let isDayValid = month == '0' || day <= self.maxDays[month - 1];
    
    if (!isDayValid) {
      day = self.maxDays[month - 1];
    }
    if (!isMonthValid) {
      month = self.maxMonth;
    }
    if (!isYearValid) {
      year = maxYear;
    }

    if (date.length >= 8) {
      let isDateValid = moment(month + '/' + day + '/' + year, "MM/DD/YYYY", true).isValid();
      if (!isDateValid) {
        return self.formatDateValue(date.slice(0, -1))
      }
    }
    if (date.length <= 2) {
      return month;
    }
    if (date.length <= 4) {
      return month + '/' + day;
    }
    if (date.length > 4) {
      return month + '/' + day + '/' + year;
    }
  };

  self.isValidDate = function(date) {
    return date && Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date);
  }

  self.convertDateToString = function(date) {
    const isDateValid = self.isValidDate(date);
    if(!isDateValid){
      return '';
    }

    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    const formattedDate = `${month}/${day}/${year}`;
    return formattedDate;
  }

  self.formatDateStringToUSFormat = function(dateString) {
    const date = new Date(dateString);

    const isDateValid = self.isValidDate(date);
    if(!isDateValid){
      return '';
    }
    
    return self.convertDateToString(date);
  }

  self.formatDateForDisplay = function(date) {
    if (!date) return '';
    
    if (typeof date === 'string' && date.match(/^\d{4}-\d{2}-\d{2}$/)) {
      const parts = date.split('-');
      return parts[1] + '/' + parts[2] + '/' + parts[0];
    }
    
    const d = new Date(date);
    if (isNaN(d.getTime())) {
      return '';
    }
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const year = d.getFullYear();
    return month + '/' + day + '/' + year;
  }
  
}]);



// WEBPACK FOOTER //
// ./src/scripts/services/formatting/dateFormattingHelper.js